import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function TrialBanner() {
  const [me, setMe] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/saas/me").then(r => setMe(r.data)).catch(() => {});
  }, []);

  if (dismissed || !me || !me.is_trial || me.trial_days_left == null) return null;

  const urgent = me.trial_days_left <= 3;

  return (
    <div className={`w-full border-b ${urgent ? "bg-red-50 border-red-200" : "bg-[#D4AF37]/10 border-[#D4AF37]/30"} px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3 text-xs sm:text-sm flex-wrap`} data-testid="trial-banner">
      <div className="flex items-center gap-2 flex-1">
        <Sparkles size={14} className={urgent ? "text-red-700" : "text-[#7a6519]"} />
        <span className={`font-semibold ${urgent ? "text-red-900" : "text-[#7a6519]"}`}>
          {me.is_expired ? "Seu trial expirou!" :
           me.trial_days_left === 0 ? "Último dia de trial!" :
           `${me.trial_days_left} dias restantes no seu trial gratuito`}
        </span>
        <span className={`hidden md:inline text-xs ${urgent ? "text-red-700" : "text-[#7a6519]/80"}`}>
          · {me.tenant?.company_name}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <Link to="/admin/billing" className={`font-bold text-xs inline-flex items-center gap-1 ${urgent ? "text-red-700 hover:underline" : "text-[#7a6519] hover:underline"}`} data-testid="banner-upgrade">
          Assinar agora <ArrowRight size={12} />
        </Link>
        <button onClick={() => setDismissed(true)} className={`${urgent ? "text-red-700" : "text-[#7a6519]/60"} hover:opacity-100 opacity-70`} aria-label="dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
